export { GlobalNav } from "./nav-global";
export { ProductPageSubNav } from "./nav-product-page";

export { GlobalNav as default } from "./nav-global";
